import {Component, OnInit} from '@angular/core';
import {ClientService} from '../../services/client.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-access-validation-message',
    templateUrl: './access-validation-message.component.html',
    styleUrls: ['./access-validation-message.component.scss']
})
export class AccessValidationMessageComponent implements OnInit {

    phone: string;
    showLoader = false;
    modalId: string;
    textMessage: string;

    constructor(public clientService: ClientService, private router: Router) {
        this.phone = sessionStorage.getItem('phone_activate_access');
        this.modalId = 'modal-error-validation';
    }

    ngOnInit(): void {
        if (!this.phone) {
            this.router.navigateByUrl('/acceso-codigo-seguridad');
        }
    }

    requestCode() {
        this.showLoader = true;
        this.clientService.requestSmsCode().subscribe(res => {
            this.showLoader = false;
            sessionStorage.setItem('sequence_activate_access_code', res.sequence);
            this.router.navigateByUrl('acceso-codigo-seguridad');
        }, error => {
            this.showLoader = false;
            this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
            document.getElementById(this.modalId).classList.remove('d-none');
        });
    }

    navigateToDniCheck() {
        this.router.navigateByUrl('activar-acceso');
    }
}
